import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    isFetchingForCourseId: false,
    entities: {},
    upcomingEventsForCourseId: null
};

const requestUpcomingEvents = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveUpcomingEvents = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.displayName]: action.upcomingEvents
        },
        isFetching: false,
        lastUpdated: action.receivedAt
    };
};

const receiveUpcomingEventsForCourseId = (state) => {
    return {
        ...state,
        isFetchingForCourseId: true
    };
};
const receiveUpcomingEventsForCourseIdSuccess = (state, { response }) => {
    return {
        ...state,
        isFetchingForCourseId: false,
        upcomingEventsForCourseId: response.data
    };
};

const receiveUpcomingEventsForCourseIdError = (state) => {
    return {
        ...state,
        isFetchingForCourseId: false
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_UPCOMING_EVENTS]: requestUpcomingEvents,
    [types.RECEIVE_UPCOMING_EVENTS]: receiveUpcomingEvents,
    [types.REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID]: receiveUpcomingEventsForCourseId,
    [types.REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_SUCCESS]: receiveUpcomingEventsForCourseIdSuccess,
    [types.REQUEST_CALENDAR_UPCOMING_EVENTS_FOR_COURSE_ID_ERROR]: receiveUpcomingEventsForCourseIdError,
    [types.RESET_UPCOMING_EVENTS]: resetToInitialState
};

export const getUpcomingEvents = (state) => {
    return state.upcomingEvents.entities;
};

export const getUpcomingEventsForCourseId = (state) => {
    return state.upcomingEvents.upcomingEventsForCourseId;
};

export default function upcomingEvents(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
